/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import countries from '@/services/country.json'
import {
  mapGetters
} from 'vuex';
import userConnectedPopup from '@/components/private/user/user-connected-request-popup/';
import userRequestApporvePopup from '@/components/private/user/user-request-apporve-popup'

export default {
  name: 'user-details',
  components: {
    userConnectedPopup,
    'request-apporve-popup' : userRequestApporvePopup 
  },
  props: [],
  data() {
    return {
      userDetails:null,
      loadmoreData: {},
      userLoading: false,
      nextStep: '',
      selfUserDetails:null,
      bioFullData: '',
      bioFullDataPopup: false,
      blogListState: {},
      blogListResults: [],
      publicBlogListState:null,
      publicBlogListResults: [],
      selfUserId: '',
      pubBlogState: true,
      is_guestuser: false,
      is_superuser: false,
      blogActv: true,
      profileUpdateAlertPopup: false,
      userProfileDetails:null,
      userProfileAvatar:true,
      countryList:[],
      getAboutInfo:null,
      userConnectedRequestState:false,
      requestApporvePopupState:false,
      requstedUserId:''
    }
  },
  computed: {
    ...mapGetters([
      'selfUserInfoGetters',
      'getAboutDetailsOfMemberUserGetters'
    ]),
    getSelfUserDetailsAgainFun() {
      this.selfUserDetails = this.$store.getters.selfUserInfoGetters.data
      return
    },
    SetIntialSuperUserStatus() {
      if (this.selfUserDetails) {
        this.is_superuser = this.selfUserDetails.is_superuser
        this.is_guestuser = this.selfUserDetails.guest
      }
      return
    },
    getAboutInfoFun(){
      this.getAboutInfo = this.$store.getters.getAboutDetailsOfMemberUserGetters.data
      return
    }
  },
  mounted() {
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getSelfUserDetailsAgainFun
    this.SetIntialSuperUserStatus
    this.getAboutInfoFun
    this.getUserDetailsAgainFun()
    bus.$on('userConnectedRequestStateBus', (data) => {
      this.userConnectedRequestState = data
      this.getUserDetailsAgainFun()
    })
    bus.$on('requestApporvePopupStateBus', (data) => {
      this.requestApporvePopupState = data
      this.getUserDetailsAgainFun()
    })
  },
  methods: {
    apporveRequestPopupMethod(roomId){
      this.requstedUserId = roomId
      this.requestApporvePopupState = true
      $('body').addClass('notConnectedUserBody')
    },
    openChatRequestPopupMethod(){
      this.userConnectedRequestState = true
      $('body').addClass('notConnectedUserBody')
    },
    getUserDetailsAgainFun() {
      this.$store.dispatch('getMemberUserDetailsFun',{id:this.$route.params.userDetailsId}).then((res)=>{
        this.userDetails = res.data.data
        this.userProfileDetails = this.userDetails.profile
        if(this.userProfileDetails.thumbnail === null){
          this.userProfileAvatar = false
        }
      })
    },
    getPubBlogListFun() {
      if(this.is_superuser){
        this.$store.dispatch('getBlogListForSuperUserAction',{id:this.$route.params.userDetailsId}).then((res)=>{
          this.publicBlogListState = res.data.data
          if (this.publicBlogListState != undefined) {
            this.publicBlogListResults = this.publicBlogListState.results
          }
        })
      }else{
        this.$store.dispatch('getPublicBlogListAction').then((res)=>{
          this.publicBlogListState = res.data.data
          if (this.publicBlogListState != undefined) {
            this.publicBlogListResults = this.publicBlogListState.results
          }
        })
      }
    },
    userInfoAlertPopupOpenFun() {
      $('body').addClass('body_right_scroll_remove')
      this.profileUpdateAlertPopup = true
    },
    userInfoAlertPopupClosedFun() {
      $('body').removeClass('body_right_scroll_remove')
      this.profileUpdateAlertPopup = false
    },
    homeFilterFun(checkItem, param) {
      $('.total_count_box').removeClass('active')
      $('#homeFilterTab' + param).addClass('active')
      if (checkItem === 'blog') {
        this.blogActv = true
      } else {
        this.blogActv = false
      }
    },
    OnlyShowMyBLogsFun() {
      if (this.pubBlogState === true) {
        this.pubBlogState = false
      } else {
        this.pubBlogState = true
      }
    },
    bioReadMoreFun(data) {
      this.bioFullData = data
      this.bioFullDataPopup = true
      $('body').addClass('body_right_scroll_remove')
      var __self = this
      $(document).click(function (event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".bio_text_read_more,.bio_more_data_popup_modal").length) {
          __self.bioFullData = ''
          __self.bioFullDataPopup = false
          $('body').removeClass('body_right_scroll_remove')
        }
      });
    },
    hideBioDataPopup() {
      this.bioFullData = ''
      this.bioFullDataPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    getCountryName(countryCode) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        country = country.name
      } else {
        country = ''
      }
      return country;
    },
  },
  watch: {
    getSelfUserDetailsAgainFun() {
      return this.$store.getters.selfUserInfoGetters
    },
    SetIntialSuperUserStatus() {
      if (this.selfUserDetails) {
        this.is_superuser = this.selfUserDetails.is_superuser
        this.is_guestuser = this.selfUserDetails.guest
      }
      return
    },
    getAboutInfoFun(){
      return this.$store.getters.getAboutDetailsOfMemberUserGetters
    }
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('body_right_scroll_remove')
    next();
  },
}